import { SlateLayout } from './layout.enum'

export const layoutsAdditionalContext: Record<
  SlateLayout,
  Record<string, any>
> = {
  BASIC: { mobileSidebarEnable: false },
  CLASSIC: { mobileSidebarEnable: false },
  DEFAULT: {},
  NO_HEADER: {},
}
